import { useEffect } from "react";
import { NavigationClient } from "@azure/msal-browser";
import { Outlet, useNavigate } from "react-router-dom";
import { Center, Stack } from "@chakra-ui/react";

import { pca } from "contexts/AzureProvider";
import ReactQueryProvider from "contexts/ReactQueryProvider";
import CustomerProvider from "contexts/CustomerProvider";
import Header from "components/Header";
import { CustomNavigationClient } from "util/NavigationClient";
import { mobileStyleBreakpoint } from "util/styleHelpers";

export const contentAreaConstraintProps = {
  maxW: "1440px",
  px: 4,
  w: "100%",
};

const HEADER_SPACING = mobileStyleBreakpoint(8, 20);
const STACK_WIDTH = mobileStyleBreakpoint("unset", "fit-content");

const AppLayout = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const navigationClient = new CustomNavigationClient(navigate);
    pca.setNavigationClient(navigationClient);
    return () => {
      pca.setNavigationClient(new NavigationClient()); // We don't have a react-router navigation context for the CustomNavigationClient
    };
  }, [navigate]);

  return (
    <ReactQueryProvider>
      <Stack spacing={HEADER_SPACING} pb={4} w={STACK_WIDTH} minW="100%">
        <Header {...contentAreaConstraintProps} />
        <Center>
          <Stack {...contentAreaConstraintProps}>
            <CustomerProvider>
              <Outlet />
            </CustomerProvider>
          </Stack>
        </Center>
      </Stack>
    </ReactQueryProvider>
  );
};

export default AppLayout;
